<template>
  <div>
    <v-alert
      v-if="!loading && reviewsPackage.type == 'trial'"
      type="info"
      icon="timelapse"
      class="py-0 mb-4"
      mb-4
      prominent
      text
      dense
      >
      <v-row align="center">
        <v-col class="grow"><strong>Proefperiode</strong> van Reviews  is actief voor {{ activeCompData.name }}. </v-col>
        <v-col class="shrink">
          <v-btn
            color="info"
            outlined
            >
             Nog {{ reviewsPackage.days }} <span style="color: #2196f3" v-if="reviewsPackage.days == 1" >dag</span><span style="color: #2196f3" v-else>dagen</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>  

    <v-container v-if="!loading && companies.length > 1" grid-list-md class="pa-0 pt-2" fluid>
      <v-layout row wrap>
        <v-flex md3 xs12>
          <v-select
            v-if="!loading && companies.length > 1 && !demoMode"
            :items="filteredCompanies"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"
            item-text="name"
            item-value="id"
            hide-details
            v-on:input="loadCompanyJourneys()"
            v-model="filter.selectedCompany"
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            outlined
            dense
            >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    prepend-inner-icon="search"
                    clearable
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
              <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
    </v-container>

    <v-card outlined v-if="!loadingUserData" class="mt-4">
      <v-container grid-list-md fluid class="ma-0 pa-1">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex md3>
            <v-select
              class="px-1"
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              :items="journeys"
              item-text="name"
              item-value="id"
              v-model="filter.selectedJourney"
              v-on:input="loadSurveyQuestions()"
              label="Journey"
              hide-details
            ></v-select>
          </v-flex>
          <v-flex md5>
            <v-select
              class="px-1"
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              :items="surveyQuestions"
              multiple
              item-text="question"
              item-value="id"
              v-model="filter.selectedQuestions"
              label="Vragen"
              hide-details
            >
              <template v-slot:selection="{item, index }">
                <span v-if="index === 0 && filter.selectedQuestions.length == surveyQuestions.length">Alle vragen geselecteerd</span>
                <span v-if="index === 0 && filter.selectedQuestions.length != surveyQuestions.length && filter.selectedQuestions.length == 1">{{filter.selectedQuestions.length }} vraag geselecteerd</span>
                <span v-if="index === 0 && filter.selectedQuestions.length != surveyQuestions.length && filter.selectedQuestions.length > 1">{{filter.selectedQuestions.length }} vragen geselecteerd</span>
            </template>
            </v-select>
          </v-flex>
          
            <v-flex md2>
            <v-menu
              ref="dateDialog"
              :close-on-content-click="false"
              v-model="filter.startDateDialog"
              transition="scale-transition"
              max-width="290px"
              min-width="290px"
              >
              <template v-slot:activator="{on}">
                <v-text-field
                  v-on="on"
                  :color="companyPrimaryColor"
                  slot="activator"
                  prepend-icon="event"
                  v-model="filterStartDateFormatted"
                  label="Start"
                  hide-details
                  readonly
                  ></v-text-field>
              </template>
              <v-date-picker
                :color="companyPrimaryColor"
                v-model="filter.startDate"
                :min="minDate"
                :max="today"
                :show-current="true"
                no-title
                @input="filter.startDateDialog = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex md2>
            <v-menu
              ref="dateDialog"
              :disabled="!filter.startDate"
              :close-on-content-click="false"
              v-model="filter.endDateDialog"
              transition="scale-transition"
              max-width="290px"
              min-width="290px"
              >
              <template v-slot:activator="{on}">
                <v-text-field
                  v-on="on"
                  :color="companyPrimaryColor"
                  slot="activator"
                  prepend-icon="event"
                  v-model="filterEndDateFormatted"
                  label="Eind"
                  hide-details
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                :color="companyPrimaryColor"
                v-model="filter.endDate"
                :min="filter.startDate"
                :max="today"
                :show-current="true"
                no-title
                @input="filter.endDateDialog = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex md8>
            <v-select
              height="38px"
              class="px-1"
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              :items="branches"
              item-text="branchName"
              item-value="id"
              v-model="filter.selectedBranches"
              multiple
              label="Vestigingen"
              attach
              hide-details
              chips
            >
              <template v-slot:selection="{ item, index }">
                <v-chip small v-if="index === 0">{{ item.branchName }}</v-chip>
                <v-chip small v-if="index === 1">{{ item.branchName }}</v-chip>
                <v-chip small v-if="index === 2">{{ item.branchName }}</v-chip>
                <v-chip small v-if="index === 3">{{ item.branchName }}</v-chip>
                <v-chip small v-if="index === 4">{{ item.branchName }}</v-chip>
                <span style="color: #666; font-size: 14px;"
                  v-if="index === 5"
                > + {{ filter.selectedBranches.length - 3}} anderen 
                </span>
              </template>
            </v-select>
          </v-flex>

          <v-flex md2>
            <v-select
              class="px-1"
              height="38px"
              :color="companyPrimaryColor"
              :items="scores"
              prepend-icon="star_half"
              item-text="name"
              item-value="id"
              v-model="filter.selectedMinScore"
              label="Maximale score"
              hide-details
            ></v-select>
          </v-flex>

          <v-flex md2>
            <v-btn
              class="mt-4"
              block
              large
              height="38px"
              :depressed="filterChanged"
              :disabled="filterChanged"
              :color="companyPrimaryColor"
              @click="loadSurveys()"
            >
              <span style="color: #fff;">Filteren</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <div v-if="loading || loadingUserData" class="blackbox-loader"></div>

    <div class="no-salon-data" v-if="!loading && noData">
      <p>Selecteer salons en klik op <strong>Filteren</strong> om data te laden.</p>
    </div>

    <v-card outlined v-if="!loading && questions.length > 0" class="mt-4">   
      <v-card-title>
        <v-text-field
          style="max-width: 300px;"
          v-model="search"
          :color="companyPrimaryColor"
          placeholder="Zoeken"
          outlined
          hide-details     
          :background-color="$vuetify.theme.themes[theme].menu"                                                
          prepend-inner-icon="search"
          autocomplete="disabled"
          clearable>
        </v-text-field>
        <v-spacer></v-spacer>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="questions"
        :search="search"
        :itemsPerPage.sync="improvementPages"
        item-key="clientName"
        class="elevation-1"
        >
        <template v-slot:item="{item}">
          <tr>
            <td>
              <div v-if="item.score" style="padding: 10px 0 0 0;">
                <span 
                  class="client-data-smiley block"
                  v-bind:class="'score-' + Math.round(item.score)"
                ></span>
                <span class="client-data-score">{{ (item.score * 2).toFixed(1) }}</span>
              </div>
            </td>
            <td>{{ item.question }}</td>
            <td style="padding-top: 8px; padding-bottom: 8px;">{{ item.feedback }}</td>
            <td>{{ item.client}}</td>
            <!-- <td>{{ item.clientEmail }}</td> -->
            <td>
              <span v-for="gender in genders" :key="gender.id">
                <span v-if="item.gender == gender.id">{{ gender.name }}</span>
              </span>
            </td>
            <td>{{ item.dateSend.seconds | moment("D MMM YYYY") }}</td>
            <td>{{ item.clientLastTreatmentByName }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import firebase from "firebase/app";
import db from "../firebase/init";
import moment from "moment";
import _ from "lodash";
import ClientDataModal from "../components/modals/ClientDataModal.vue";

export default {
  components: {
    "client-data-modal": ClientDataModal
  },
  name: "improvements",
  data: () => ({
    search: "",
    loading: true,
    loadingUserData: true,
    noData: true,
    improvementPages: 50,
    searchCompanies:"",
    activeCompData: null,
    activeCompDataOriginal:null,
    filter: {
      selectedCompany: null,
      selectedBranches: [],
      selectedJourney: [],
      selectedQuestions: [],
      startDate: null,
      startDateDialog: false,
      endDate: null,
      selectedMinScore: 3,
      endDateDialog: false,
    },

    filterSaved: {
      selectedCompany: null,
      selectedBranches: [],
      selectedJourney: [],
      selectedQuestions: [],
      startDate: null,
      startDateDialog: false,
      endDate: null,
      selectedMinScore: 3,
      endDateDialog: false,
    },
    minDate: null,
    today: null,
    journeys: [],
    branches: [],
    companies: [],
    surveys: [],
    questions: [],
    surveyQuestions: [],
    scores: [
      {
        id: 1,
        name: "2"
      },
      {
        id: 2,
        name: "4"
      },
      {
        id: 3,
        name: "6"
      },
      {
        id: 4,
        name: "8"
      },
      {
        id: 5,
        name: "10"
      }
    ],
    genders: [
      {
        id: "male",
        name: "Man"
      },
      {
        id: "female",
        name: "Vrouw"
      }
    ],
    headers: [
      {
        text: "Score",
        align: "left",
        value: "score",
        width: "100px"
      },
      {
        text: "Vraag",
        align: "left",
        value: "question",
        width: "150px"
      },
      {
        text: "Feedback",
        align: "left",
        value: "feedback",
      },
      {
        text: "Klant",
        align: "left",
        value: "client",
        width: "150px"
      },
      {
        text: "Geslacht",
        align: "left",
        value: "gender",
        width: "100px"
      },
      {
        text: "Datum",
        align: "left",
        value: "dateSend",
        width: "120px"
      },
      {
        text: "Medewerker",
        align: "left",
        value: "client",
        width: "120px"
      },
      
    ],
    clients: [],
    selectedJourneyLanguage: null,
  }),

  created() {
    this.loadUserComp();
    this.today = moment().format("YYYY-MM-DD");
  },

  methods: {
    loadUserComp() {
      this.loadingUserData = true;
      this.loading = true;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        if(this.userRole == 'superadmin'){
          db.collection("companies")
          .get()
          .then(snap => {
            this.companies = [];
            snap.forEach(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
            });
          })
          .then(()=>{
            resolve();
          })
        }
        else{
          this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let company = {};
              company.name = doc.data().name;
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
          })
        }
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.filter.selectedCompany = this.companies[selectedCompanyIndex].id;
              this.loadCompanyJourneys();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.filter.selectedCompany = this.companies[0].id;
              this.loadCompanyJourneys();
            }
          }
          // No selected company is set 
          else {
            this.filter.selectedCompany = this.companies[0].id;
            this.loadCompanyJourneys();
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.filter.selectedCompany = this.companies[0].id;
          this.loadCompanyJourneys();
        }
      })
    },

    loadActiveCompData() {
      db.collection("companies")
        .doc(this.filter.selectedCompany)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
        })
        .catch(error => {
          console.log("Error getting document:", error);
        });
    },

    // De journeys die horen bij de geselecteerde company binnenhalen
    loadCompanyJourneys() {
      window.localStorage.setItem('selectedCompany', this.filter.selectedCompany)
      this.loadActiveCompData();
      this.loadingUserData = true;
      this.loading = true;
      this.journeys = [];
      db.collection("journeys")
        .where(`companies.${this.filter.selectedCompany}`, "==", true)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let journeyCollection = doc.data();
            journeyCollection.id = doc.id;
            this.journeys.push(journeyCollection);
          });
        })

        .then(() => {
          if (this.journeys.length > 0) {
            // Journeys gevonden
            this.filter.selectedJourney = this.journeys[0].id;
            this.selectedJourneyLanguage = this.journeys[0].selectedLanguages[0];
            this.loadBranches();
          } else {
            // Geen journeys gevonden
            this.filter.selectedJourney = null;
            this.noData = true;
            this.loading = false;
          }
        })
        .catch(() => {
          console.error("Error bij laden journeys: ", error);
        });
    },

    // Load Branches van geselecteerd bedrijf
    loadBranches() {
      this.branches = [];
      if (this.userRole == "superadmin" || this.userRole == "admin") {
        db.collection("branches")
          .where("compId", "==", this.filter.selectedCompany)
          .get()
          .then(snap => {
            snap.forEach(doc => {
              let branchCollection = doc.data();
              branchCollection.id = doc.id;
              this.branches.push(branchCollection);
            });
          })
          .then(() => {
            if (this.branches.length > 0) {
              let branchesArray = []
              let counter = 0
              new Promise((resolve, reject)=>{
                this.branches.forEach(branch=>{
                  branchesArray.push(branch.id)
                  counter++
                  if(counter == this.branches.length){
                    resolve()
                  }
                })
              })
              .then(()=>{
                this.filter.selectedBranches = branchesArray;
                this.loadSurveyQuestions();
              })
            
            } else {
              this.filter.selectedBranches = null;
              this.noData = true;
              this.loading = false;
            }
          });
      } else {
        if (this.userBranches.length > 0) {
          let counter = 0;
          new Promise((resolve, reject) => {
            this.userBranches.map(branch => {
              db.collection("branches")
                .doc(branch)
                .get()
                .then(doc => {
                  let branchCollection = doc.data();
                  branchCollection.id = doc.id;
                  this.branches.push(branchCollection);
                  counter++;
                  if (counter == this.userBranches.length) {
                    resolve();
                  }
                });
            });
          })
          .then(() => {
            if (this.branches.length > 0) {
              let branchesArray = []
              let counter = 0
              new Promise((resolve, reject)=>{
                this.branches.forEach(branch=>{
                  branchesArray.push(branch.id)
                  counter++
                  if(counter == this.branches.length){
                    resolve()
                  }
                })
              })
              .then(()=>{
                this.filter.selectedBranches = branchesArray;
                this.loadSurveyQuestions();
              })
            }
          });
        } else {
          this.filter.selectedBranches = null;
          this.noData = true;
          this.loading = false;
        }
      }
    },

    // QUESTIONS
    loadSurveyQuestions() {
      db.collection("questions")
        .where("journeyId", "==", this.filter.selectedJourney)
        .get()
        .then(snap => {
          this.surveyQuestions = [];
          snap.forEach(doc => {
            if (doc.data()) {
              // console.log("Vraag: ", doc.data())
              let question = {};
              question.id = doc.id;
              question.question = doc.data().question[this.selectedJourneyLanguage];
              
              this.surveyQuestions.push(question);
              this.filter.selectedQuestions.push(question.id);
            }
          });
        })

        .then(()=>{
          if (this.surveyQuestions.length > 0) {
            // console.log("Groter dus doorgaan!")
            this.checkMinimumDate();
          }
          else {
            // console.log("Niet groter dus afbreken!")
            this.loadingUserData = false;
            this.filter.selectedQuestion = null;
            this.noData = true;
            this.loading = false;
          }
        })
    },

    // Kijken wat de eerste datum was van een survey
    checkMinimumDate() {
      let minDates = [];
      let noData = false;
      let counter = 0;

      new Promise((resolve, reject) => {
        this.filteredBranches.forEach(branch => {
          if (branch.firstSurveyDate) {
            let dateNumberSeconds = Number(branch.firstSurveyDate.seconds);
            minDates.push(dateNumberSeconds);
          }
          counter++;
          if (counter == this.filteredBranches.length) {
            resolve();
          }
        });
      })
        .then(() => {
          if (minDates.length > 0) {
            let minDate = Math.min.apply(null, minDates);
            this.minDate = moment.unix(minDate).format("YYYY-MM-DD");
            let thirtyDaysAgo = moment.unix().subtract(30, "days");

            if (minDate < thirtyDaysAgo) {
              this.filter.selectedStartDate = moment
                .unix(thirtyDaysAgo)
                .format("YYYY-MM-DD");
            } else {
              this.filter.startDate = moment.unix(minDate).format("YYYY-MM-DD");
            }
            this.filter.endDate = moment().format("YYYY-MM-DD");
          } else {
            noData = true;
          }
        })
        .then(() => {
          if (!noData) {
            this.loadingUserData = false;
            if(this.filteredBranches.length == 1){
              this.noData = false;
              this.loadSurveys();
            }
            else{
              this.loading = false;
              this.noData = true
            }
          } 
          else {
            this.loadingUserData = false;
            this.noData = true;
            this.loading = false;
          }
        });
    },

    loadSurveys() {
      this.filterSaved = _.cloneDeep(this.filter);
      this.loading = true;
      this.surveys = [];
      let start = new Date(this.filter.startDate);
      let end = new Date(this.filter.endDate);

      let counter = 0;

      new Promise((resolve, reject) => {
        this.filteredBranches.map(branch => {
          db.collection("surveys")
            .where("journeyId", "==", this.filter.selectedJourney)
            .where("branchId", "==", branch.id)
            .where("dateSend", ">=", start)
            .where("dateSend", "<=", end)
            .where("answered", "==", true)
            .orderBy("dateSend")
            .get()
            .then(snap => {
              snap.forEach(doc => {
                let survey = doc.data();
                survey.id = doc.id;
                survey.expanded = false;
                this.surveys.push(survey);
              });
            })
            .then(() => {
              counter++;
              if (counter == this.filteredBranches.length) {
                resolve();
              }
            })
            .catch(error => {
              counter++;
              if (counter == this.filteredBranches.length) {
                resolve();
              }
              console.error("Error bij binnenhalen van surveys van " + branch.name + ": ", error);
            });
        });
      })
      .then(() => {
        // console.log("Surveys zijn binnengehaald");
      })
      .then(() => {
        if (this.surveys.length > 0) {
          this.loadQuestions();
          this.noData = false;
        } else {
          this.noData = true;
          this.loading = false;
        }
      });
    },

    setMininumDateOne() {
      let minDateBranches = this.minDateBranchOne;

      if (minDateBranches.length > 0) {
        this.minDateOne = moment
          .unix(Math.min.apply(null, minDateBranches))
          .format("D MMM YYYY");
        this.startOne = moment.unix(Math.min.apply(null, minDateBranches));
        this.selectedStartDateOne = moment.unix(
          Math.min.apply(null, minDateBranches)
        );
      } else {
        this.selectedStartDateOne = moment();
        this.startOne = moment();
        this.minDateOne = moment()
          .subtract(1, "month")
          .add(1, "days");
      }
    },

    loadQuestions() {
      // console.log("Load questions");
      this.questions = [];

      let clientSurveyCounter = 0;
      new Promise((resolve, reject) => {
        this.surveys.map(survey => {
          survey.surveyQuestions.map(question => {
            
            if((question.rating <= this.filter.selectedMinScore && _.indexOf(this.filter.selectedQuestions, question.id) >= 0) || (!question.rating && question.feedback && _.indexOf(this.filter.selectedQuestions, question.id) >= 0) || (question.rating <= this.filter.selectedMinScore && question.feedback && _.indexOf(this.filter.selectedQuestions, question.id) >= 0)) {
              // console.log("question: ", question)
              let questionsItem = {};
              questionsItem.client = survey.clientName;
              questionsItem.question = question.question[survey.clientLanguage];
              if (question.rating) {
                questionsItem.score = question.rating;
              }
              if(question.feedback){
                questionsItem.feedback = question.feedback;
              }
              questionsItem.gender = survey.clientGender;
              questionsItem.dateSend = survey.dateSend;
              questionsItem.clientLastTreatmentByName = survey.clientLastTreatmentByName;
              this.questions.push(questionsItem);
            }
          });

          clientSurveyCounter++;
          if (clientSurveyCounter == this.surveys.length) {
            resolve();
          }
        });
      }).then(() => {
        this.noData = false
        this.loading = false;
      });
    },

    // Datum omvormen naar Europese leesbare datum
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    }
  },

  computed: {
    reviewsPackage(){
      let packageStatus = { 
        type: 'inactive',
        days: 0
      }

      if(this.activeCompData.packages && this.activeCompData.packages.length > 0 && _.indexOf(this.activeCompData.packages, 'customerjourney') >= 0){
        packageStatus.type = 'active';
      }
      else{
        // Package not purchased, check for active trial
        if(this.activeCompData.trials && this.activeCompData.trials.length > 0){
          this.activeCompData.trials.forEach(trailPackage =>{
            if(trailPackage.id == 'customerjourney'){
              // Trial found, check if trialperiod is still active
              if(moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days') > moment()){
                packageStatus.type = 'trial';
                packageStatus.days = moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days').diff(moment(), 'days')
              }
            }
          })
        }
      }
      return packageStatus
    },

    filteredBranches(){
      let branches = []
      this.branches.forEach(branch=>{
        this.filter.selectedBranches.forEach(selectedBranch=>{
          if(selectedBranch == branch.id){
            branches.push(branch)
          }
        })
      })
      return branches
    },

    demoMode(){
      return this.$store.state.demoMode;
    },
        
    // Datum omvormen naar Europese leesbare datum
    filterStartDateFormatted() {
      return this.formatDate(this.filter.startDate);
    },

    filterEndDateFormatted() {
      return this.formatDate(this.filter.endDate);
    },
    
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    userBranches() {
      return this.$store.state.userBranches;
    },
    userId() {
      return this.$store.state.userId;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    filterChanged() {
      if (_.isEqual(this.filter, this.filterSaved) == false) {
        return false;
      } else {
        return true;
      }
    },
    filteredCompanies(){
      if(this.searchCompanies && this.searchCompanies.length > 0){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies
      }
    }
  }
};
</script>
